import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import menu from './menu'
import dealers from './dealers'
import charts from './charts'
import dealerScores from './dealer-scores'
import dealerDivisionScores from './dealer-division-scores'
import branches from './branches'
import branchScores from './branch-scores'
import branchDivisionScores from './branch-division-scores'
import branchTypes from './branch-types'
import evaluations from './evaluations'
import evaluationAnswers from './evaluation-answers'
import periods from './periods'
import layouts from './layouts'
import assignments from './assignments'
import divisions from './divisions'
import permissions from './permissions'
import users from './users'
import roles from './roles'
import profile from './profile'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    menu,
    dealers,
    charts,
    dealerScores,
    dealerDivisionScores,
    branches,
    branchScores,
    branchDivisionScores,
    branchTypes,
    evaluations,
    evaluationAnswers,
    periods,
    layouts,
    assignments,
    divisions,
    permissions,
    users,
    roles,
    profile
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js